import React, { useState, useEffect } from 'react'
import Typography from '@mui/material/Typography';
import ContactUsStyles from './ContactUs.module.css';
import { Box, Button } from '@mui/material';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import { Link } from 'react-router-dom';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import axios from 'axios';

export const ContactUs = () => {



    const [addressData, setAddressData] = useState();

    const formatDate = (date) => {
        return date ? new Date(date).toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' }).replace(/\//g, '.') : '';
    };


    // -------------------------------------------------------------------------------------------------------------------------
    const getAddressData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_COSMOSADMIN}/address/getAllAddress`
            )
            setAddressData(res.data)
            const dates = res.data.map((item) => {
                const [day, month, year] = item.date.split('.');
                return (
                    new Date(year, month - 1, day).getTime()
                )
            })
            const maxDate = new Date(Math.max(...dates));
            setAddressData(maxDate);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getAddressData()
    }, [])


    // -------------------------------------------------------------------------------------------------------------------------



    return (
        <div className={ContactUsStyles.contactUsMain}>
            <div className={ContactUsStyles.contactUsContent}>
                <Typography sx={{ marginTop: '2%', color: '#121926', fontWeight: '600', fontSize: '20px', paddingBottom: '3%' }} >
                    Contact us
                </Typography>
                <Box className={ContactUsStyles.contactUsComponent}>
                    <div className={ContactUsStyles.contactUsComponentLeft}>
                        <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Title
                        </Typography>
                    </div>
                    <div className={ContactUsStyles.contactUsComponentRight}>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Last modified
                        </Typography>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Action
                        </Typography>
                    </div>
                </Box>
                <Box className={ContactUsStyles.contactUsComponent}>
                    <div className={ContactUsStyles.contactUsComponentLeft}>
                        <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Branch Address
                        </Typography>
                    </div>
                    <div className={ContactUsStyles.contactUsComponentRight}>
                        <Typography variant='h6' sx={{ fontSize: '15px' }}>
                           {formatDate(addressData)}
                        </Typography>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            <Link to='/branchaddress'>
                                <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                            </Link>
                        </Typography>
                    </div>
                </Box>
            </div>
        </div>
    )
}

export default ContactUs